// extracted by extract-css-chunks-webpack-plugin
module.exports = {"info_name":"info_name_RNiwd","label_icon":"label_icon_3abkg","popper_class_tooltip":"popper_class_tooltip_ezz+0","title":"title_nQEPp","ui_mask":"ui_mask_Rk3bZ"};